exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-performers-js": () => import("./../../../src/pages/performers.js" /* webpackChunkName: "component---src-pages-performers-js" */),
  "component---src-templates-artist-page-js": () => import("./../../../src/templates/artist-page.js" /* webpackChunkName: "component---src-templates-artist-page-js" */)
}

